module.exports = __webpack_public_path__ + "static/media/report_7.335a8fac.jpg";